import DynamicForm from "../DynamicForm/DynamicForm";
import { useState } from "react";
import { Button, Spacer } from "@components/atoms";
import { ButtonType } from "@components/atoms/Button/types";
import { getButtonCategory } from "../Share/utils/utils";
import { useStockItemRequest } from "@apis/BMH";
import { useUserInfo } from "@redux/slices/userInfoSlice";
import { messageType } from "../PopUp/types";
import { useGetPdpSectionLayout } from "../../../hooks/useGetSectionLayout";
import { PdpSections } from "@utils/customization";
import {
  filterAndSortFormData,
  mapDataToIframeLabels,
} from "../DynamicForm/utils";
import { useTranslation } from "react-i18next";
import { IframeRequestScreenProps } from "./types";
import ConfirmationPopup from "@components/atoms/ConfirmationPopUp";
import { getProduct } from "./utils";
import { SpaceType } from "@components/atoms/Spacer/types";
import { useTheme } from "styled-components/native";
import styled from "styled-components/native";
import { css } from "styled-components/native";
import { useDynamicFormState } from "@scenes/bulk-request/context/DynamicFormContext";
import { useJewelryConfiguratorState } from "@scenes/configurator/JewelryConfigurator/Context/JewelryConfiguratorContext";
import { ProductCategory } from "@utils/constants";

const IframeRequestScreen = ({
  onClose,
  itemDetail,
  productType,
}: IframeRequestScreenProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const priceMode = useUserInfo().getUserPriceMode();
  const { dynamicFormValues, isDynamicFormValid } = useDynamicFormState();
  const stockItemRequest = useStockItemRequest();
  const sectionLayout = useGetPdpSectionLayout(
    PdpSections.CUSTOM_BMH,
    itemDetail?.type
  );
  const { jcSelectedOption, personalization } = useJewelryConfiguratorState();

  const formData =
    filterAndSortFormData(sectionLayout?.iFrame_bmh, priceMode) ?? [];

  const { iframe_user_details, store_customer_attributes } =
    mapDataToIframeLabels(dynamicFormValues.requestForm, formData);

  const handleEvent = () => {
    (stockItemRequest as any).mutate(
      {
        comments: dynamicFormValues.requestForm.comments,
        iframe_user_details: iframe_user_details,
        store_customer_attributes: store_customer_attributes,
        price_mode: priceMode,
        request_type: `${getProduct(itemDetail?.type)}_iframe`,
        stock_item_id: itemDetail?.id,
        ...((productType === ProductCategory.JEWELRY ||
          productType === ProductCategory.LABGROWN_JEWELRY) && {
          additional_attributes: {
            config: jcSelectedOption?.current?.option_value || {},
            personalization: personalization || {},
          },
        }),
      },
      {
        onSuccess() {
          setShowSuccessPopup(true);
        },
      }
    );
  };

  const closeSuccessPopup = () => {
    setShowSuccessPopup(false);
    onClose();
  };

  const handleSubmitForm = () => {
    handleEvent();
  };

  return (
    <>
      <Overlay>
        <CenterContainer>
          <DynamicForm form={formData} hideSubmitButton={true} />

          <Spacer size={SpaceType.Double} />
          <Button
            title={t("iframe.request.popUp.button.text")}
            type={ButtonType.primary}
            category={getButtonCategory(itemDetail?.type)}
            onPress={handleSubmitForm}
            disabled={
              !isDynamicFormValid?.requestForm?.isValid ||
              stockItemRequest.isLoading
            }
            loading={stockItemRequest.isLoading}
            {...(theme.isTablet && { maxWidth: 343 })}
          />
        </CenterContainer>
      </Overlay>
      <ConfirmationPopup
        title={t("iframe.request.successPopUp.title.text")}
        htmlMessage={t("iframe.request.successPopUp.description.text")}
        primaryButtonTitle={t("iframe.request.successPopUp.button.text")}
        primaryButtonAction={closeSuccessPopup}
        category={getButtonCategory(itemDetail?.type)}
        messageType={messageType.Success}
        opened={showSuccessPopup}
      />
    </>
  );
};

const Overlay = styled.View`
  ${({ theme }) =>
    theme.isTablet &&
    css`
      align-items: center;
    `}
`;

const CenterContainer = styled.View`
  ${({ theme }) =>
    theme.isTablet &&
    css`
      align-items:center
      max-width: 608px;
    `}
`;

export default IframeRequestScreen;
